module.exports = __webpack_public_path__ + "static/media/lungs.fc947b60.png";